import { ReduxAction } from './../../constants';
const initialState = {};

const datasetDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ReduxAction.datasets: {
      return {
        ...state,
        datasetDetails: action.payload?.datasetDetails,
      };
    }
    default:
      return state;
  }
};
export default datasetDetailsReducer;
